"use strict";
// Category type definitions — mirrors Django DRF API response shapes.
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=category.js.map